module.exports = __webpack_public_path__ + "static/media/profile.c288e3dd.jpg";